import { LoadingOutlined } from '@ant-design/icons'
import { Card, ConfigProvider, Spin, Typography } from 'antd'
import { useIndicationRecommendations } from 'features/indicationTriage/api/indicationRecsApi'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import React, { FC } from 'react'
import styled from 'styled-components'
import { useGeckoTheme } from 'styles/GeckoTheme'

const { Text } = Typography
const RecommendationListContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const RecommendationContainer = styled.div`ckea
  margin-bottom: 1rem;
  width: 100%;
`

export const Title = () => 'Indication Recommendation'
export const Width = '36rem'
export const CardView: FC<IndicationDetailCardProps> = () => {
  const { indication: item } = useIndicationData()
  const { recs, isLoading } = useIndicationRecommendations(item?.id)

  const { theme } = useGeckoTheme()

  return (
    <Spin indicator={<LoadingOutlined />} size='large' spinning={!!isLoading}>
      <RecommendationListContainer>
        <ConfigProvider
          theme={{
            components: {
              Card: {
                colorBgContainer: theme.forecast.background2,
              },
            },
          }}>
          {recs ? (
            recs.map((rec) => (
              <RecommendationContainer key={rec.id}>
                <Card title={rec.title} variant='outlined'>
                  <Text>{rec.content}</Text>
                </Card>
              </RecommendationContainer>
            ))
          ) : (
            <></>
          )}
        </ConfigProvider>
      </RecommendationListContainer>
    </Spin>
  )
}
